import { render, staticRenderFns } from "./property-list-item-skeleton.vue?vue&type=template&id=7d8f60a1&scoped=true"
import script from "./property-list-item-skeleton.vue?vue&type=script&lang=js"
export * from "./property-list-item-skeleton.vue?vue&type=script&lang=js"
import style0 from "./property-list-item-skeleton.vue?vue&type=style&index=0&id=7d8f60a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8f60a1",
  null
  
)

export default component.exports